import * as yup from 'yup';
import { createYupSchema, VALIDATION_RULES } from './validationRules';

// Utiliser les schémas depuis validationRules.ts pour cohérence
export const { eventSchema, userSchema } = createYupSchema();

// Schéma spécial pour les brouillons (draft) - beaucoup plus permissif
export const createDraftEventSchema = () => {
  return yup.object({
    title: yup.string()
      .required(VALIDATION_RULES.event.title.messageServer)
      .min(VALIDATION_RULES.event.title.minLength, VALIDATION_RULES.event.title.messageServer)
      .max(VALIDATION_RULES.event.title.maxLength, VALIDATION_RULES.event.title.messageServer),
    
    organizerId: yup.string()
      .required(VALIDATION_RULES.event.organizerId.messageServer),
    
    status: yup.string()
      .oneOf(['draft', 'active'], 'Le statut doit être draft ou active'),
    
    // Tout le reste est optionnel pour les drafts
    description: yup.string().optional(),
    location: yup.string().optional(),
    locationName: yup.string().optional(),
    latitude: yup.number().optional(),
    longitude: yup.number().optional(),
    date: yup.date().optional(),
    time: yup.string().optional(),
    endTime: yup.string().optional(),
    tags: yup.array().optional(),
    prices: yup.array().optional(),
    image: yup.string().optional(),
    ticketingUrl: yup.string().optional()
  });
};

// Fonction pour mapper les données du formulaire au format Yup
function mapDataForYupValidation(data: any) {
  return {
    ...data,
    // Mapper les coordonnées au format attendu par Yup
    coordinates: data.latitude && data.longitude ? {
      lat: data.latitude,
      lng: data.longitude
    } : undefined,
    
    // Mapper datetime au format date si présent
    date: data.datetime || data.date,
    
    // S'assurer que les champs optionnels sont définis
    description: data.description || undefined,
    location: data.location || undefined,
    locationName: data.locationName || undefined,
    endTime: data.endTime || undefined
  };
}

// Fonction de validation améliorée avec support draft/publish
export async function validateServerSide(data: any, schema: yup.Schema, mode: 'draft' | 'publish' = 'publish') {
  try {
    // Choisir le schéma selon le mode ou le statut des données
    let schemaToUse = schema;
    
    // Si c'est un draft ou si explicitement demandé, utiliser le schéma permissif
    if (mode === 'draft' || data.status === 'draft') {
      schemaToUse = createDraftEventSchema();
    }
    
    // Mapper les données au format attendu par le schéma
    const mappedData = mapDataForYupValidation(data);
    
    const validatedData = await schemaToUse.validate(mappedData, {
      abortEarly: false,
      stripUnknown: true
    });
    return { success: true, data: validatedData };
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      const validationError = error as yup.ValidationError;
      return {
        success: false,
        errors: validationError.errors,
        fields: validationError.inner.reduce((acc: Record<string, string>, err: yup.ValidationError) => {
          if (err.path) acc[err.path] = err.message;
          return acc;
        }, {} as Record<string, string>)
      };
    }
    throw error;
  }
} 